import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon, USER_INTERFACE_ARROW_04_RIGHT } from '@bwoty-web/styleguide';
import './nugget.scss';

const Nugget = ({ heading, children, className, onClick }) => {
  return (
    <div className={cx('gw-hotel-nugget', className)}>
      <button
        type="button"
        className="gw-hotel-nugget__heading"
        onClick={onClick}
      >
        <h3>{heading}</h3>
        <Icon path={USER_INTERFACE_ARROW_04_RIGHT} size="s" sizeMobile="s" />
      </button>
      <div className="gw-hotel-nugget__content">{children}</div>
    </div>
  );
};

Nugget.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

Nugget.defaultProps = {
  className: null,
};

export default Nugget;
